import SingFestWrapUp from './SingFestWrapUp';
export default SingFestWrapUp;
